export const offerContentSelector = store => store.offer.offerContent;
export const isLoadingOfferSelector = store => store.offer.isLoading;
export const errorOfferSelector = store => store.offer.error;
